// Paginate the expanded variant cards, rather than their parent products.
(() => {
  async function initialize(grid) {
    if (grid.dataset.paginationReady) return;
    grid.dataset.paginationReady = 'true';
    const nav = grid.parentElement.querySelector('.mx-pagination');
    if (!nav) return;
    const pageSize = Number(grid.dataset.cardPageSize) || 75;
    const sourcePages = Number(grid.dataset.sourcePages);
    const sourcePage = Number(grid.dataset.sourcePage);
    const batches = [];
    try {
      for (let page = 1; page <= sourcePages; page++) {
        if (page === sourcePage) {
          batches.push([...grid.children]);
          continue;
        }
        const url = new URL(window.location.href);
        url.searchParams.delete('card_page');
        url.searchParams.set('page', page);
        url.searchParams.set('section_id', grid.dataset.sectionId);
        const response = await fetch(url);
        if (!response.ok) throw new Error('Collection request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = doc.querySelector('.mx-collection-products');
        if (!source) throw new Error('Collection cards missing');
        batches.push([...source.children]);
      }
    } catch (error) {
      // Keep Shopify's original cards and pagination if a request fails.
      delete grid.dataset.paginationReady;
      return;
    }
    const cards = batches.flat();
    const pageCount = Math.ceil(cards.length / pageSize);
    function showPage(scroll = false) {
      const url = new URL(window.location.href);
      const requested = Number.parseInt(url.searchParams.get('card_page') || '1', 10);
      const current = Math.max(1, Math.min(pageCount, requested || 1));
      grid.replaceChildren(...cards.slice((current - 1) * pageSize, current * pageSize));
      nav.replaceChildren();
      nav.hidden = pageCount <= 1;
      function link(page, title, label) {
        const anchor = document.createElement('a');
        const target = new URL(url);
        target.searchParams.delete('page');
        target.searchParams.delete('section_id');
        target.searchParams.set('card_page', page);
        anchor.href = target.pathname + target.search;
        anchor.textContent = title;
        if (label) anchor.setAttribute('aria-label', label);
        anchor.addEventListener('click', (event) => {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          window.history.pushState(null, '', anchor.href);
          showPage(true);
        });
        nav.append(anchor);
      }
      if (current > 1) link(current - 1, '‹', 'Previous page');
      for (let page = 1; page <= pageCount; page++) {
        if (page === current) {
          const active = document.createElement('span');
          active.className = 'current';
          active.setAttribute('aria-current', 'page');
          active.textContent = page;
          nav.append(active);
        } else {
          link(page, String(page));
        }
      }
      if (current < pageCount) link(current + 1, '›', 'Next page');
      if (scroll) grid.scrollIntoView({ block: 'start' });
    }
    showPage();
    window.addEventListener('popstate', () => {
      if (grid.isConnected) showPage();
    });
  }
  function initializeAll() {
    document.querySelectorAll('.mx-collection-products[data-card-page-size]').forEach(initialize);
  }
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
